import React, { useState } from "react";
import { useDataProvider, useNotify, useRedirect } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

const RoutePlanEditButton = (record: IBusSchedulePlans) => {
  const [loading, setLoading] = useState<boolean>(false);
  const provider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();

  const handleDuplicateRoutePlan = async () => {
    setLoading(true);
    try {
      await provider.customUpdate(`busSchedulePlans/${record.id}/duplicate`, {
        data: {},
      });
      setLoading(false);

      redirect(`/busSchedulePlans/${record.id}/`);
    } catch (error: any) {
      setLoading(false);
      notify(
        `Failed duplicate the route plan, error: ${error.message}`,
        "warning"
      );
    }
  };

  return (
    <StyledButton variant="outlined" onClick={handleDuplicateRoutePlan}>
      {loading ? "Duplicating..." : "Edit"}
    </StyledButton>
  );
};

export default RoutePlanEditButton;
